import React from "react";

const Pixelfed = ({ className, width, height }) => {
    const w = (typeof width !== 'undefined') ? width : 32;
    const h = (typeof height !== 'undefined') ? width : 32;
    return (
        <svg className={className} width={`${w}px`} height={`${h}px`} viewBox="-10 -5 1034 1034" xmlns="http://www.w3.org/2000/svg">
            <path d="M500 176q-115 0 -215 58q-96 57 -152 153q-58 99 -58 214.5t58 214.5q56 96 152 152q100 58 215 58t215 -58q96 -56 152 -152q58 -99 58 -214.5t-58 -214.5q-56 -96 -152 -153q-100 -58 -215 -58zM432 435h112q36 0 66.5 17.5t48.5 47t18 65t-18 65t-48.5 47t-66.5 17.5 h-78l-111 106v-290q0 -31 22.5 -53t54.5 -22z" />
        </svg>
    )
}


export default Pixelfed